const state = {
    available_systems: [],
    system_types: [],
    operation_databases_info: {},
    operation_existing_databases_selected: []
};

const getters = {
    databasesForDomain: (state) => (domainId) => {
        return state.available_databases[domainId];
    }
};

const actions = {
    setCheckState({ commit }, payload) {
        commit("setCheckState", payload);
    },

    getDatabasesForDomain({ commit }, payload) {
        return new Promise((resolve, reject) => {
            let databases = [];
            let r = this._vm.$laroute.route("environments.get_databases", { domain_id: payload });
            this._vm.$axios
                .get(r)
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        for (let database of response.data.data) {
                            if (database.users.length > 0) {
                                databases.push(database);
                            }
                        }

                        resolve(JSON.parse(JSON.stringify(databases)));
                    } else {
                        console.log("fm4vmi#654385");
                        console.log(response);
                        reject(response.data);
                    }
                })
                .catch((error) => {
                    console.log("fm4vmi#654386");
                    console.log(error);
                    reject(error);
                })
                .finally(() => {});
        });
    },
    resetOperationDatabases({ commit }) {
        commit("resetOperationDatabases");
    },
    getDbSystemsForDomain({ commit }, payload) {
        commit("resetAvailableSystems");
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("environments.get_db_systems", { domain_id: payload.domain_id });
            this._vm.$axios
                .get(r)
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        commit("addAvailableSystems", response.data.data.systems);
                        commit("addSystemTypes", response.data.data.system_types);
                        resolve(response);
                    } else {
                        console.log("fm4vmi#63443235");
                        reject(response.data);
                    }
                })
                .catch((error) => {
                    console.log("fm4vmi#654386");
                    console.log(error.response);
                    reject(error);
                })
                .finally(() => {});
        });
    }
};

const mutations = {
    addAvailableSystems(state, db_systems) {
        state.available_systems = [];
        for (let i = 0; i < db_systems.length; i++) {
            state.available_systems.push(db_systems[i]);
        }
    },
    addSystemTypes(state, system_types) {
        state.system_types = [];
        for (let i = 0; i < system_types.length; i++) {
            state.system_types.push(system_types[i]);
        }
    },
    resetAvailableSystems(state) {
        state.available_systems.splice(0, state.available_systems.length);
    },

    setCheckState(state, { checked, source_database_id, install_type, target_database_info }) {
        if (checked === true) {
            let new_obj = {
                database_info: target_database_info,
                install_type: install_type
            };
            state.operation_databases_info[source_database_id] = Object.assign(
                {},
                state.operation_databases_info[source_database_id],
                new_obj
            );
        } else {
            if (state.operation_databases_info.hasOwnProperty(source_database_id)) {
                this._vm.$delete(state.operation_databases_info, source_database_id);
            }
        }

        // clear the selected ids so we can compute remaining databases for the selects
        state.operation_existing_databases_selected = [];
        for (let item in state.operation_databases_info) {
            if (state.operation_databases_info[item].install_type === "existing") {
                state.operation_existing_databases_selected.push(
                    state.operation_databases_info[item].database_info.db_id
                );
            }
        }
        // console.log(install_type, state.operation_databases_info);
    },
    resetOperationDatabases(state) {
        state.operation_databases_info = {};
        state.operation_existing_databases_selected = [];
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
